module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noItemsText":"No news to show."},"fi":{"noItemsText":"Uutisia ei löytynyt."},"sv":{"noItemsText":"Det finns inga nyheter att visa."}}')
  delete Component.options._Ctor
}
